import React, { useState, useRef,useEffect } from "react";
import ImmediateSessionDot from "../ImmediateSessionDot";
import moment from "moment";
import Search from "../../../../components/search";
import { filterList } from "../data";
import { useSelector } from "react-redux";
import Sorting from "../../../../components/sorting";
import Button from "../../../../components/button";
import Pagination from "../../../../components/tablePagination";
import Select from "react-select";
import { fireFilter } from "../functions";
import { useNavigate, useSearchParams } from "react-router-dom";
import CsvDownload from "../../../../components/csvdownload";
import { session_id_beg, session_id_end } from "../../../../utils/helpers";
import AppointmentInfoPanel from "../AppointmentInfoPanel";
import Filter from "../../../../components/filter";
import UpdateAppointments from "../../Subcomponents/updateappt";
import CopyComponent from "../../../../components/copyComponent";
import {ExportData} from "../../../../services/admin";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

var apptAvatarPalettes = [
  { background: '#f5e6d8', color: '#b87040' },
  { background: '#faf0e8', color: '#c07838' },
  { background: '#eeddd0', color: '#a86030' },
  { background: '#f7ece0', color: '#d5a67b' },
  { background: '#f0e0cc', color: '#b87848' },
];
function apptGetInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function apptGetAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % apptAvatarPalettes.length : 0;
  return Object.assign({}, apptAvatarPalettes[idx], {
    width: 36, height: 36, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', fontSize: '13px', flexShrink: 0,
  });
}



export default function EndedEarlyAppointments(props) {
  const {
    showAppointment,
    filterListAppointments,
    getPaginationData,
    setFilterValues,
    setSearchValues,
    filterReset,
    endedEarlyAppointmentsPage,
    endedEarlyAppointmentsrowsPerPage,
    searchValue,
    filterValues,
    serviceTypeList,
    changeHandlerFilter,
    serviceFilterValue,
    setSortingNameOrderBy,
    setSortingTabType,
    getAllAppointmentsList,
    activeTab,
    setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,
    setFilterValueOptions,
    filterValueOptions,
    setServiceTypeShow,
    serviceTypeShow,
    exportDownload,
    searchValueFilter,
    onTransferCount,
    setEndedEarlyCount,
    setEndedEarlyAppontmets,
    isSearching

    
  } = props;
  // const copyMeetingLink = (url) => {
  //   navigator.clipboard.writeText(url);
  // };
  const { allEndedEarly } = useSelector((state) => state.users);
   useEffect(() => {
         
          if (filterOprater && Object.keys(searchValue).length > 0) {
          const newValues = {
            filterValues: { ...searchValue },
            operator: filterOprater
          };
    
        console.log("NEW VALUES:", newValues);
          filtersRef.current = newValues; 
        }
      
        }, [])

  const [updateItem, setUpdateItem] = useState({});
  const [filters, setFilters] = useState({ filterValues: { screen_name: ""}, operator: "" });
             const filtersRef = useRef({ filterValues: {}, operator: "" });
             const [isFilterDirty, setIsFilterDirty] = useState(true);
             const [panelAppointment, setPanelAppointment] = useState(null);
             const [panelViewType, setPanelViewType] = useState('appointment');

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const openUpdateappointmentBox = (item) => {
    setUpdateItem(item)
    window.loadModal2('#UpdateAppointments', 'show')
  }
  let info = JSON.parse(localStorage.getItem('paginationAppointment'))
  const navigateEdit = (e, id) => {
     window.renderFirst = false
     console.log(e.target.className);
    if (e.target.className == "capitalize_medium") {
       navigate(`/profile-edit/${id.medium_id}?&searchURL=appointments&view=5&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
    } 
    if(e.target.className == "capitalize_client"){
      if(id.client_user_type == 3){
        navigate(`/edit/${id.client_id}?&searchURL=appointments&view=5&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      }else{
        navigate(`/profile-edit/${id.client_id}?&searchURL=appointments&view=5&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      }
    }
  };

  const handleSessionClick = (e, appoinment, columnType = 'appointment') => {
    if (e.target.closest && e.target.closest('button, a, input, select, textarea, [role="button"], .toggle-button-cover')) {
      return;
    }
    e.stopPropagation();
    if (columnType === 'medium' && !appoinment.medium_details) {
      columnType = 'appointment';
    }
    if (columnType === 'client' && !appoinment.client_details) {
      columnType = 'appointment';
    }
    setPanelViewType(columnType);
    setPanelAppointment(Object.assign({}, appoinment, {
      sessionIdDisplay: session_id_beg + appoinment.id + session_id_end,
    }));
  };

  const getAppointmentsNewList = () => {

    const info = {
      page: endedEarlyAppointmentsPage,
      rowsPerPage: endedEarlyAppointmentsrowsPerPage,
    };
    getAllAppointmentsList(info, activeTab)
    window.loadModal2('#UpdateAppointments', 'hide')
  }

  const createString =() => {

    let string = `screen_name=${
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : ""}&session_type=${searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : ""}&session_id=${searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : ""}&name=${
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : ""}&medium_email=${
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : ""}&client_email=${
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : ""}&meeting_id=${
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          :""}&created_at=${searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : ''}&oprater=${filterOprater !== undefined ? filterOprater : ""}&country=${searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""}
      `
      return string;
  }
  const exportData =()=>{
        let info = {
              appoitment_type: "endearly", appoitment_value: 4,queryString: createString()
          }
      ExportData(info).then((data) => {
              if (data.data.status) {
                  toast.success(data.data.message, { position: "top-center" });
              }
              }).catch(() => { })
        }

        const exportAllData = () => {
          let info = {
            appoitment_type: "endearly", 
            appoitment_value: 4,
            queryString: "" 
          }
          ExportData(info).then((data) => {
            if (data.data.status) {
              toast.success("All data exported successfully", { position: "top-center" });
            }
          }).catch(() => { })
        }

        const getAppointmentsNewListData = (toName, id ) => {
    console.log(`Updated: moved one from to ${toName}`);
    window.loadModal2('#UpdateAppointments', 'hide')
    setEndedEarlyAppontmets((prev) => prev.filter((item) => item.id !== id));
    dispatch(
            setEndedEarlyCount(
              allEndedEarly - 1
              )
          )
    onTransferCount( "Ended Early", toName);
    
  
    // you can call API or refresh appointment list here
  };
  const fliterdata = (name, oprater) => {
  const newValues = {
    filterValues: { ...name },
    operator: oprater
  };
console.log("NEW VALUES:", newValues);
  filtersRef.current = newValues; // <--- instant update (no delay)
  setFilters(newValues);
  setIsFilterDirty(false);          // UI update (async, but that's fine)
};


const LoadData = () => {
  // optional: clear old UI result before new search
  console.log("FILTERS USED:", filtersRef.current.filterValues, filtersRef.current.operator);


// setUpcomingAppointments([]);
  filterListAppointments(
    filtersRef.current.filterValues,
    filtersRef.current.operator
  );
  setIsFilterDirty(true);
};
  return (
    <>
      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th className="min-width-100"> Session #</th>
              <th>
                {/* <input type="checkbox" id="one" />
                <label htmlFor="one"></label> */}
                Medium Name
              </th>
              <th>Client Name</th>
              <th>
                <div className="d-flex align-items-center">
                  <span>Date &amp; Time</span>
                  <Sorting tab={6} callApi={filterListAppointments} view={'admin'} types={'date'} setSortingNameOrderBy={setSortingNameOrderBy} setSortingTabType={setSortingTabType} />
                </div>
              </th>

              <th>Session Name</th>
              {/* <th>Meeting Link</th> */}
              <th>Date &amp; Time<br />Cancelled</th>
              <th>Ended Early By</th>
              <th>Status</th>
              <th><div className="d-inline-flex align-items-center align-items-center">
                <span> Created at</span>{" "}
                <Sorting tab={6} callApi={filterListAppointments} view={'admin'} types={'created_at'} setSortingNameOrderBy={setSortingNameOrderBy}
                  setSortingTabType={setSortingTabType} />
              </div></th>
              {/* <th>Action</th> */}
            </tr>
             {isSearching ? (
               <tr>
    <td colSpan="12" className="text-center py-4">
      <div className="custom-loader">
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
      </div>
      <div className="loader-text mt-2">Loading appointments...</div>
    </td>
  </tr>
                ) :
            showAppointment.length > 0 ? (
              showAppointment.map((appoinment) => (
                <tr onClick={(e) => handleSessionClick(e, appoinment)} className="innr" style={{ cursor: 'pointer' }}>
                  {/* <td>{session_id_beg + appoinment.id + session_id_end}</td> */}
                  <td className="pointer" onClick={(e) => handleSessionClick(e, appoinment)}>


                    <div className="d-flex align-items-center">
                      <ImmediateSessionDot appointment={appoinment} /><div className="mr-1 mt-1"><CopyComponent value={session_id_beg + appoinment.id + session_id_end} /></div>
                      <div className="mt-1">{session_id_beg + appoinment.id + session_id_end}</div>
                      <div className="mr-1 mt-1 ml-1">
                        {appoinment.backfill_code !== null ? <>
                          ({appoinment.backfill_code})
                        </> : <></>
                        }
                      </div>
                    </div>
                  </td>
                  {/* <td>
                  
                    <span className="capitalize">{appoinment.medium_name}&nbsp;({appoinment.medium_email}) </span>
                  </td>
                  <td>
                    <span className="">{appoinment.client_name}&nbsp;({appoinment.client_email})</span>
                    <>{appoinment.client_comment === true && (<b style={{
                      fontSize: '22px',
                    }}>*</b>)}</>
                  
                  </td> */}
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_medium' } }, appoinment); }}>
                    {/* <input type="checkbox" id="two" />
                    <label htmlFor="two"></label> */}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {appoinment.medium_profile_image ? (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_medium' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                            <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.medium_profile_image} alt="" />
                          </div>
                        ) : (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_medium' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.medium_name)}>{apptGetInitials(appoinment.medium_name)}</div>
                        )}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span className="capitalize_medium" style={{ display: 'block' }}>{appoinment.medium_name} {appoinment.medium_comment === true && (<b style={{ fontSize: '22px' }}>*</b>)}</span>
                          <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {appoinment.medium_email} <CopyComponent value={appoinment.medium_email} />
                          </div>
                        </div>
                      </div>
                    </div>

                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_client' } }, appoinment); }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {appoinment.client_profile_image ? (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_client' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                            <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.client_profile_image} alt="" />
                          </div>
                        ) : (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_client' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.client_name)}>{apptGetInitials(appoinment.client_name)}</div>
                        )}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span className="capitalize_client" style={{ display: 'block' }}>{appoinment.client_name} {appoinment.client_comment === true && (<b style={{ fontSize: '22px' }}>*</b>)}</span>
                          <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {appoinment.client_email} <CopyComponent value={appoinment.client_email} />
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
                  <td className="width-190px ">{appoinment.guest_booking == 1 ? (<b style={{
                          fontSize: '22px',
                        }}>*</b>) : ""}{appoinment.session_name}</td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.modifiedDate ? appoinment.modifiedDate.split(',')[0] : ''}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.modifiedDate && appoinment.modifiedDate.split(',')[1] ? appoinment.modifiedDate.split(',')[1].trim() : ''}</div>
                  </td>
                  <td>{appoinment.userby}</td>
                  <td>

                    <Button
                      status={0}
                      onClick={(e) => openUpdateappointmentBox(appoinment)}
                      type="button"
                      className={`resend-btn w-130`}
                      title="Change Status"
                    />

                  </td>
                  <td>
                    {appoinment.createdDate ? (
                      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.5' }}>
                        <span>{appoinment.createdDate.split(',')[0]}</span>
                        <span style={{ color: '#888', fontSize: '12px' }}>{(appoinment.createdDate.split(',')[1] || '').trim()}</span>
                      </div>
                    ) : ''}
                  </td>
                  {/* <td>
                    <div>
                      <p className="d-flex">
                        <div> Client:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.client_email}{" "}
                        </div>
                      </p>
                      <p className="d-flex">
                        {" "}
                        <div>Medium:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.medium_email}
                        </div>
                      </p>
                    </div>
                  </td> */}
                  {/* <td>Practice - 60 Min (30 Min each)</td> */}
                  {/* <td className="googl-link">
                    <a
                      className="appointment-links"
                      href={appoinment.meeting_link}
                      target="_blank"
                    >
                      {appoinment.meeting_link}
                    </a>
                    <img
                      onClick={() => copyMeetingLink(appoinment.meeting_link)}
                      className="googl-link-copy-img "
                      alt="copy"
                      src="images/copy.png"
                    />
                  </td> */}

                  {/* <td className="change">
                    <a href="#">
                      <img src="../images/email-blu.png" />
                      Email
                    </a>
                  </td> */}
                  {/* <td className="dot-image">
                    <img src="../images/Unionblck.png" />
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}

          </tbody>
        </table>
                </div>
        <Pagination
          rowsPerPageOptions={[25, 50, 100]}
          count={allEndedEarly}
          activeTab={"endedEarlyAdmin"}
          getPaginationData={getPaginationData}
          endedEarlyAppointmentsPage={endedEarlyAppointmentsPage}
          endedEarlyAppointmentsrowsPerPage={endedEarlyAppointmentsrowsPerPage}
        />
        <UpdateAppointments
          updateItem={updateItem}
          appType={['Complete', 'Cancel', 'No Show', 'Restrict']}
          getAppointmentsNewList={getAppointmentsNewListData}
        />
        <AppointmentInfoPanel
          appointment={panelAppointment}
          viewType={panelViewType}
          onClose={() => setPanelAppointment(null)}
          onMediumClick={(appt) => navigateEdit({ target: { className: 'capitalize_medium' } }, appt)}
          onClientClick={(appt) => navigateEdit({ target: { className: 'capitalize_client' } }, appt)}
        />
      </div>
    </>
  );
}
